'use client'

import { Controller } from 'react-hook-form'

import Range from '../../Vanilla/Range'

const RangeField = ({ name, min, max, control, rules = null, customClass }) => {
  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      defaultValue={max / 2}
      render={({ field }) => (
        <Range
          name={name}
          min={min}
          max={max}
          customClass={customClass}
          value={field.value}
          onBlur={field.onBlur}
          onChange={field.onChange}
        />
      )}
    />
  )
}

export default RangeField
